'use client';

import { cn } from '@upme/ui/lib/utils';

type CheckboxProps = {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  className?: string;
  id?: string;
  disabled?: boolean;
};

function Checkbox({ checked, onCheckedChange, className, id, disabled }: CheckboxProps) {
  return (
    <input
      type="checkbox"
      id={id}
      checked={checked}
      disabled={disabled}
      onChange={(e) => onCheckedChange?.(e.target.checked)}
      className={cn(
        'size-4 rounded border border-input bg-background accent-primary cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
    />
  );
}

export { Checkbox };
